"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SITE_NAME = exports.SCRAPED_FORM_NOTIFICATION_EMAIL_LIST = exports.PORTAL_TIMEZONE_NAME = exports.PORTAL_CREATION_UTC = exports.POPUP_SUGGESTED_COLORS = exports.MARKETING_FREE_SETTINGS = exports.FORM_CAPTURE_ENABLED = exports.EMPTY = exports.DOMAIN = exports.APP_STYLE = exports.ADMIN_EMAIL_ADDRESS = void 0;
var ADMIN_EMAIL_ADDRESS = 'adminEmailAddress';
exports.ADMIN_EMAIL_ADDRESS = ADMIN_EMAIL_ADDRESS;
var APP_STYLE = 'appStyle';
exports.APP_STYLE = APP_STYLE;
var DOMAIN = 'domain';
exports.DOMAIN = DOMAIN;
var EMPTY = 'empty';
exports.EMPTY = EMPTY;
var FORM_CAPTURE_ENABLED = 'formCaptureEnabled';
exports.FORM_CAPTURE_ENABLED = FORM_CAPTURE_ENABLED;
var MARKETING_FREE_SETTINGS = 'MarketingFreeSettings';
exports.MARKETING_FREE_SETTINGS = MARKETING_FREE_SETTINGS;
var POPUP_SUGGESTED_COLORS = 'popupSuggestedColors';
exports.POPUP_SUGGESTED_COLORS = POPUP_SUGGESTED_COLORS;
var PORTAL_CREATION_UTC = 'portalCreationUtc';
exports.PORTAL_CREATION_UTC = PORTAL_CREATION_UTC;
var PORTAL_TIMEZONE_NAME = 'portalTimezoneName';
exports.PORTAL_TIMEZONE_NAME = PORTAL_TIMEZONE_NAME;
var SCRAPED_FORM_NOTIFICATION_EMAIL_LIST = 'scrapedFormNotificationEmailList';
exports.SCRAPED_FORM_NOTIFICATION_EMAIL_LIST = SCRAPED_FORM_NOTIFICATION_EMAIL_LIST;
var SITE_NAME = 'siteName';
exports.SITE_NAME = SITE_NAME;